import { visionURL } from "../config/environment";
import Jsona from "jsona";
import JsonApiService from "../services/jsonapiService";
import { useState, useEffect } from "react";
import visionCallService from "../services/visionCallService";

const dataFormatter = new Jsona();

// Temporary fix to handle quiz data not being in correct json api spec format
// but homework data is being sent in correct json api spec format so we need to handle them differently
const convertToJsonApiSpecFormat = response => {
  if (response.data && response.data.type === "contentable") {
    // homework type is being sent as "contentable"
    return dataFormatter.deserialize(response);
  } else {
    return visionCallService.extractAttributes(response);
  }
};

const contentableApiService = async () =>
  new JsonApiService("course_contentables", {
    baseUrl: `${visionURL}/learning_center/api`,
    credentials: "include"
  });

export const useCourseContentable = (contentableId, coursePreview) => {
  const [isLoading, setIsLoading] = useState(false);
  const [courseContentable, setCourseContentable] = useState(null);

  let custom;
  if (coursePreview) {
    custom = { preview: true };
  }

  useEffect(() => {
    const fetchContentable = async () => {
      if (contentableId) {
        setIsLoading(true);
        const service = await contentableApiService();
        const response = await service
          .customParams(custom)
          .find(contentableId)
          .then(response => response.json());
        setIsLoading(false);
        setCourseContentable(convertToJsonApiSpecFormat(response));
      }
    };
    fetchContentable();
  }, [contentableId]);

  return { courseContentable, isLoading };
};
